import { getRoute } from '@/router/helpers';
import { FeatureFlag } from '@/contexts/feature/helpers';
import { IconType } from '../icon/helpers';

export type SidebarItem = {
  key: string;
  label: string;
  icon?: IconType;
  link?: string;
  target?: string;
  feature?: FeatureFlag;
  comingSoon?: boolean;
  parent?: string;
};

export type SidebarSection = {
  key: string;
  title: string;
  items: SidebarItem[];
};

export const SidebarSections: SidebarSection[] = [
  {
    key: 'observe',
    title: 'Observe',
    items: [
      {
        key: 'user-events',
        ...getRoute('user-events'),
      },
      {
        key: 'insights',
        ...getRoute('insights'),
      },
    ],
  },
  {
    key: 'govern',
    title: 'Govern',
    items: [
      {
        key: 'default-policy',
        ...getRoute('default-policy-v1'),
        feature: 'hasPolicyV1',
      },
      {
        key: 'group-policies',
        ...getRoute('group-policies'),
        feature: 'hasPolicyV1',
      },
      {
        key: 'policy-v2',
        label: 'Policy',
        icon: 'policy',
        feature: 'hasPolicyV2',
      },
      {
        key: 'default-policy',
        ...getRoute('default-policy'),
        feature: 'hasPolicyV2',
        parent: 'policy-v2',
      },
      {
        key: 'scope-policies',
        ...getRoute('scope-policies'),
        feature: 'hasPolicyV2',
        parent: 'policy-v2',
      },
      {
        key: 'override-policies',
        ...getRoute('override-policy'),
        feature: 'hasPolicyV2',
        parent: 'policy-v2',
      },
      {
        key: 'catalogs',
        label: 'Catalogs',
        icon: 'catalog',
      },
      {
        key: 'public-services',
        parent: 'catalogs',
        ...getRoute('public-services'),
      },
      {
        key: 'mcp-servers',
        parent: 'catalogs',
        ...getRoute('mcp-servers'),
      },
      {
        key: 'private-models',
        ...getRoute('private-models'),
      },
      {
        key: 'data-sources',
        ...getRoute('data-sources'),
      },
      {
        key: 'agents',
        ...getRoute('agents'),
      },
      {
        key: 'classifiers',
        ...getRoute('classifiers'),
        feature: 'hasClassifiers',
      },
    ],
  },
  {
    key: 'configure',
    title: 'Configure',
    items: [
      {
        key: 'org-settings',
        ...getRoute('org-settings'),
      },
      {
        key: 'identity',
        label: 'Users & Groups',
        icon: 'manage-accounts',
      },
      {
        key: 'admin-users',
        ...getRoute('admin-users'),
        feature: 'canManageAdmins',
        parent: 'identity',
      },
      {
        key: 'users',
        ...getRoute('users'),
        parent: 'identity',
      },
      {
        key: 'groups',
        ...getRoute('groups'),
        parent: 'identity',
      },
      {
        key: 'connectors',
        ...getRoute('connectors'),
      },
      {
        key: 'telemetry',
        ...getRoute('telemetry'),
      },
      {
        key: 'audit-logs',
        ...getRoute('audit-logs'),
      },
    ],
  },
];
